export default function transformMaskedPan(maskedPan = '') {
  return maskedPan.replace('_________', '...');
}
